import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Features from "@/components/Features";
import Faq from "@/components/Faq";
import SupportForm from "@/components/SupportForm";
import Footer from "@/components/Footer";
import Privacy from "@/components/Privacy";
import Terms from "@/components/Terms";

const Landing = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <Features />
            <Faq />
            <SupportForm />
        </main>
        <Footer />
    </>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
        setLenis(lenis);
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <div className="bg-[#06070B] min-h-screen text-slate-50" data-testid="app-root">
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="dark" position="bottom-right" richColors />
        </div>
    );
}

export default App;
